import React, { useState } from "react";
import { Link } from "react-router-dom";
import ImageWithoutBasePath from "../imageWithoutBasePath";

interface UserProfileHeaderProps {
  photo?: string | null;
  firstName: string;
  lastName: string;
  subtitle?: string;
  imageSize?: number;
  compact?: boolean;
  to?: string;
  canRedirect?: boolean;
  nameMaxWidth?: number;
}

const UserProfileHeader: React.FC<UserProfileHeaderProps> = ({
  photo,
  firstName,
  lastName,
  subtitle,
  imageSize = 50,
  compact = false,
  to,
  canRedirect = true,
  nameMaxWidth = 200,
}) => {
  const [imageSrc, setImageSrc] = useState(photo || "/assets/img/profiles/fake-image.png");
  const avatarSize = compact ? 36 : imageSize;
  const nameClass = compact ? "mb-0 fs-6" : "mb-0";
  const subtitleClass = compact ? "text-muted fs-7" : "text-muted";
  const fullName = `${firstName} ${lastName}`;

  const handleImageError = () => {
    setImageSrc("/assets/img/profiles/fake-image.png");
  };

  const content = (
    <div className="d-flex align-items-center">
      <div className="avatar me-3">
        <ImageWithoutBasePath
          src={imageSrc}
          alt={fullName}
          className="rounded-circle"
          width={avatarSize}
          height={avatarSize}
          onError={handleImageError}
        />
      </div>

      <div className="flex-grow-1" style={{ minWidth: 0 }}>
        <span
          className={`${nameClass} d-inline-block text-truncate`}
          style={{ maxWidth: nameMaxWidth }}
          title={fullName}
        >
          {fullName}
        </span>

        {subtitle && (
          <div
            className={`${subtitleClass} text-truncate`}
            style={{ maxWidth: nameMaxWidth }}
            title={subtitle}
          >
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );

  return to && canRedirect ? (
    <Link to={to} className="text-decoration-none text-dark">
      {content}
    </Link>
  ) : (
    content
  );
};

export default UserProfileHeader;